var map = {
	"./install0.png": 317,
	"./install1.png": 318,
	"./install2.png": 319,
	"./install3.png": 320,
	"./install4.png": 321,
	"./install5.png": 322,
	"./install6.png": 323,
	"./install7.png": 324,
	"./install8.png": 325,
	"./install9.png": 326,
	"./stop-sign.png": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316;